export const STATE_LOGIN = 'LOGIN';
export const STATE_FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const STATE_CONFIRM_FORGOT_PASSWORD = 'CONFIRM_FORGOT_PASSWORD';
export const STATE_PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const STATE_LOGIN_CONFIRMATION = 'LOGIN_CONFIRMATION';

export const LOGIN_ERROR_INVALID_CREDENTIALS = 'INVALID_CREDENTIALS';
export const LOGIN_ERROR_NO_SUBSCRIPTION = 'NO_SUBSCRIPTION';
export const DMI_SUPPORT_EMAIL = 'dmi.support@diligent.com';
